const clickCheck = (open, listRef, buttonRef, setOpen, e) => {
    if (open && listRef.current && !listRef.current.contains(e.target)
        && buttonRef.current && !buttonRef.current.contains(e.target)) {
        setOpen(false)
    }
}

export default clickCheck;